<template>
  <div class="ws-info-switch-tabs">
    <v-tabs
      :value="value"
      background-color="transparent"
      color="#116795"
    >
      <v-tab
        v-for="(tab,tabIndex) in tabs"
        :key="tabIndex"
        class="ws-info-switch-tabs__tab"
        @click="$_onClick(tabIndex)"
      >
      </v-tab>
    </v-tabs>
  </div>
</template>
<script>
export default {
  name: "WsInfoSwitchTabs",
  props: {
    value: {
      type: Number,
      default: 0,
    },
    tabs: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    $_onClick($event) {
      this.$emit("input", $event);
    },
  },
};
</script>
<style lang="scss">
@import "@/__vue2cmsstonevuetify/assets/scss/ws-info-switch-tabs.scss";
</style>